import { useEffect } from 'react';

const SELECTOR =
  '.reveal, .reveal-up, .reveal-scale, .reveal-left, .reveal-right, .stagger-children';

/**
 * Observes all reveal-elements in the DOM and adds the `active` class
 * when they enter the viewport. Re-runs after each route-mount.
 */
export function useRevealOnScroll(deps: React.DependencyList = []) {
  useEffect(() => {
    const elements = document.querySelectorAll(SELECTOR);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' },
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
